import React from 'react';

const About = () => {
    return (
        <div className='conatiner mx-auto py-5 px-5'>
            <h1 className='text-danger text-center'>About Us</h1>
            <p>We are trying to build a community where everyone will be able to buy their product very easily. We have a large amount of delivery persons of our own. In order to build trust among customers we check the quality of the products twice through our quality assurance team. They are working hard to find the best quality product. We also have a Review group. They continously listen to the customers and try to understand their feedbacks.</p>

        </div>
    );
};

export default About;